import styled from "styled-components"

export const BaseButtonLabel = styled.span`
  display: inline-flex;
  align-items: center;

  min-width: var(--size-10);
  height: 100%;
  padding: 0 var(--size-4);

  box-sizing: border-box;
  border-radius: 4px 0 0 4px;

  > svg:first-child {
    margin-right: var(--size-2);
  }
  > svg:last-child {
    margin-left: var(--size-2);
  }
  > svg:first-child:last-child {
    margin: 0;
  }

  .variant--labeled-outlined & {
    color: var(--main-text-color, var(--main-color));
    background-color: var(--color-layout-main);
    border: 2px solid var(--main-color);
    padding: 0 calc(var(--size-4) - 2px);
  }
`
export const BaseLabeled = styled.span<{
  rounded?: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 0 4px 4px 0;
  ${(props) => props.rounded && "border-radius: 0 9999px 9999px 0;"}

  svg:not([fill]) {
    fill: var(--main-label-color, currentColor);
  }
  .size--small & {
    width: var(--size-9);
  }
  .size--default & {
    width: var(--size-10);
  }

  .variant--labeled & {
    border-left: 1px solid var(--main-dark-color);
  }
  .variant--labeled-dark & {
    background-color: var(--main-dark-color);
  }
`

export const BaseButton = styled.button<{
  rounded?: boolean
  fullWidth?: boolean
}>`
  display: inline-flex;
  justify-content: center;
  position: relative;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 4px;
  ${(props) => props.fullWidth && "width: 100%;"}
  ${(props) => props.rounded && "border-radius: 9999px;"}

  &.loading ${BaseLabeled}, &.loading ${BaseButtonLabel} {
    visibility: hidden;
  }
  :disabled {
    cursor: not-allowed;
    > * {
      opacity: 0.4;
    }
  }
  svg:not([fill]) {
    fill: currentColor;
  }
  &:not(.variant--link) {
    &.size--small {
      height: var(--size-9);
    }
    &.size--default {
      height: var(--size-10);
    }
  }
  &.variant--link {
    background-color: transparent;
    &.color--default {
      color: var(--color-text-300);
    }
    &.color--primary {
      color: var(--color-primary);
    }
    &.color--secondary {
      color: var(--color-secondary);
    }
    &.color--warning {
      color: var(--color-accent2);
    }
    &.color--danger {
      color: var(--color-error);
    }
    &.color--success {
      color: var(--color-success);
    }
  }

  :not(.variant--link) {
    &.color--default {
      color: var(--color-text-300);
      background-color: var(--color-neutral-50);
      --main-color: var(--color-neutral-50);
      --main-text-color: var(--color-neutral-300);
      --main-label-color: var(--color-neutral-400);
      --main-dark-color: var(--color-neutral-100);
    }
    &.color--primary {
      color: var(--color-text-0);
      background-color: var(--color-primary);
      --main-color: var(--color-primary);
      --main-dark-color: var(--color-primary-dark);
    }
    &.color--secondary {
      color: var(--color-text-0);
      background-color: var(--color-secondary);
      --main-color: var(--color-secondary);
      --main-dark-color: var(--color-secondary-dark);
    }
    &.color--warning {
      color: var(--color-text-0);
      background-color: var(--color-accent2);
      --main-color: var(--color-accent2);
      --main-dark-color: var(--color-accent2-dark);
    }
    &.color--danger {
      color: var(--color-text-0);
      background-color: var(--color-error);
      --main-color: var(--color-error);
      --main-dark-color: var(--color-error-dark);
    }
    &.color--success {
      color: var(--color-text-0);
      background-color: var(--color-success);
      --main-color: var(--color-success);
      --main-dark-color: var(--color-success-dark);
    }
  }
  &&.variant--outlined {
    background-color: transparent;
    color: var(--main-text-color, var(--main-color));
    border: 1px solid var(--main-color);
  }
`

export const BaseLoading = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  > svg {
    width: var(--size-10);
    height: var(--size-6);

    .size--small & {
      width: var(--size-8);
    }
  }
`
